// extracted by mini-css-extract-plugin
export var navbarSubLink = "z_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "z_tm d_f0 d_dB";
export var subPageLink = "z_gf d_gf";
export var burger = "z_tM";
export var sublinkSize = "z_tN";
export var linkSize = "z_tP";
export var Link = "z_ry s_ry s_qM s_q5";